import { j as e } from "../../../../_virtual/jsx-runtime.js";
import { forwardRef as n } from "react";
import x from "../../SkeletonWrapper/index.js";
import { cn as r } from "../../../../lib/utils.js";
import d from "../../../../assets/icons/Check.js";
import { styles as s } from "./styles.js";
const h = n(
  ({
    isLoading: t,
    className: i,
    label: o,
    labelClassName: l,
    variant: m = "outline",
    ...c
  }, a) => /* @__PURE__ */ e.jsx(x, { isLoading: t, children: /* @__PURE__ */ e.jsxs("div", { className: r("flex items-center", s[m].container), children: [
    /* @__PURE__ */ e.jsxs("div", { className: "relative flex", children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          type: "checkbox",
          ref: a,
          className: r(s.base, s[m].checkbox, i),
          id: c.id || c.name,
          ...c
        }
      ),
      /* @__PURE__ */ e.jsx(
        d,
        {
          className: r(s[m].checkIcon),
          "aria-hidden": "true"
        }
      )
    ] }),
    o && /* @__PURE__ */ e.jsx(
      "label",
      {
        htmlFor: c.id || c.name,
        className: r(s[m].label, l),
        children: o
      }
    )
  ] }) })
);
h.displayName = "CheckboxInput";
export {
  h as default
};
